import React from "react";

import { Checkbox as MantineCheckbox} from '@mantine/core';


export const Checkbox : React.FC<Props> = (props : Props) : JSX.Element => {

    return (

        <MantineCheckbox
        label={props.label}
        checked={props.checked}
        onClick={props.onClick}
        />

  );    

};

export const SliderCheckbox : React.FC<Props> = (props : Props) : JSX.Element => {

    return (

        <span title={props.label} className="switch-container" style={props.style} >
            <label className="switch">
                <input
                    type="checkbox"
                    onClick={props.onClick}
                    defaultChecked={props.checked}
                />
                <div className="slider round">
                </div>
            </label>
      </span>

  );    

};

export const SliderCheckboxLabeled : React.FC<Props> = (props : Props) : JSX.Element => {
    const label : JSX.Element = props.checked ? <span className="slider-label-on">{props.onLabel}</span> : <span className="slider-label-off">{props.offLabel}</span>;

    return (

        <span title={props.label} className="switch-container" style={props.style} >
            <label className="switch labeled">
                <input
                    type="checkbox"
                    onClick={props.onClick}
                    defaultChecked={props.checked}
                />
                <div className="slider labeled round">
                    {label}
                </div>
            </label>
      </span>

  );    

};



interface Props {
    readonly label : string;
    readonly checked : boolean ;
    readonly onClick : React.MouseEventHandler<HTMLInputElement>  | undefined;
    readonly style? : Record<string,string>
    readonly onLabel: string;  
    readonly offLabel: string; 
}

